import { Table } from '@unistocks/components/table/table';
import { Paragraph } from '@unistocks/components/text/text';
import { TransactionDto } from '@unistocks/proxy/axios-client';
import { formatCurrency, formatDate, t } from '@unistocks/shared/localization/index.ts';
import { GetProps } from 'tamagui';

export type TransactionRowProps = GetProps<typeof Table.Row> & {
  transaction: TransactionDto;
};

export const TransactionRow: React.FC<TransactionRowProps> = ({ transaction, ...props }) => {
  return (
    <Table.Row pressable hoverable {...props}>
      <Table.Cell cellLocation="first">
        <Paragraph>{formatDate(transaction.date, { dateStyle: 'short' })}</Paragraph>
      </Table.Cell>

      <Table.Cell cellLocation="middle">
        <Paragraph>{t(`::Enum:TransactionType:${transaction.type}`)}</Paragraph>
      </Table.Cell>

      <Table.Cell cellLocation="last" alignCells={{ x: 'end' }}>
        <Paragraph>{formatCurrency(transaction.amount)}</Paragraph>
      </Table.Cell>
    </Table.Row>
  );
};

TransactionRow.displayName = 'TransactionRow';
